"use client";
import dynamic from "next/dynamic";

const ChatbotIndex = dynamic(() => import("./Index"), {
  ssr: false,
});

const Chatbot = () => {
  return <ChatbotIndex />;
};

export default Chatbot;
